import React, { useState } from 'react'
import { useField } from 'formik'
import { SingleDatePicker as DatePicker } from 'react-dates'
import { ICON_AFTER_POSITION } from 'react-dates/constants'

import CalendarIcon from 'components/Icons/Calendar'

import { Container, Label, PrevIcon, NextIcon, ErrorText } from './styles'

const SingleDatePicker = ({ label, name, ...props }) => {
  const [focused, setFocused] = useState(false)
  const [{ value }, meta, { setValue }] = useField({ name, ...props })

  const isError = meta.touched && meta.error

  return (
    <Container focused={focused} error={isError} {...props}>
      <Label disabled={props.disabled} focused={focused} error={isError}>
        {label}
      </Label>
      <DatePicker
        onDateChange={date => setValue(date)}
        date={value}
        customInputIcon={<CalendarIcon />}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        showDefaultInputIcon
        inputIconPosition={ICON_AFTER_POSITION}
        numberOfMonths={1}
        navPrev={<PrevIcon />}
        navNext={<NextIcon />}
        showClearDate={value ? true : false}
        {...props}
      />
      {isError && <ErrorText>{meta.error}</ErrorText>}
    </Container>
  )
}

export default SingleDatePicker
